import doIconColorImage from "../../../../src/pages/foundations/tokens/design-tokens/_assets/do-icon-color-image.png";
import dontIconColor from "../../../../src/pages/foundations/tokens/design-tokens/_assets/dont-icon-color.png";
import * as React from 'react';
export default {
  doIconColorImage,
  dontIconColor,
  React
};